import { useEffect } from "react";

const CountdownTimer = ({ remainingSeconds,setRemainingSeconds }) => {
    useEffect(() => {
      const interval = setInterval(() => {
        setRemainingSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
  
      if (remainingSeconds === 0) {
        clearInterval(interval);
      }
  
      return () => clearInterval(interval);
    }, [remainingSeconds]);
  
  };
  
  export default CountdownTimer;